import styled from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import Box from 'component/layoutComponents/Box';
import HyperLink from 'component/commonComponents/hyperLink/hyperLink';

type UptimeTheme = typeof DefaultUptimeTheme;

export const StyledContent = styled(Box)(
  ({ theme, numberOwnTeams }: { theme: UptimeTheme, numberOwnTeams: number }) => `
  height: ${numberOwnTeams <= 5 ? 'auto' : '210px'};

  .MuiDataGrid-root {
    border: 0;
  };

  .MuiDataGrid-columnSeparator {
    svg {
      display: none;
    }
  };

  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
    padding-left: 14px;
    font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
    font-family: ${theme.uptimeFonts.primary};
  }

  .spacing-left {
    padding-left: 14px;
  }

  .MuiDataGrid-row:last-child {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

`,
);

export const StyledThumbNail = styled.div(({ theme }: { theme: UptimeTheme }) => `
  background-color: ${theme.uptimeColors.mainTheme.primary};
  width: 22px;
  height: 22px;
  text-transform: uppercase;
  border-radius: 4px;
  margin-right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    color: ${theme.uptimeColors.grayScales.gray};
    font-size: ${theme.uptimeFontSizes.desktop.fz1}px !important;
    font-family: ${theme.uptimeFonts.primary};
  }
`);

export const Text = styled.div(({ theme }: { theme: UptimeTheme }) => `
  font-size: ${theme.uptimeFontSizes.desktop.fz1}px !important;
  color: ${theme.uptimeColors.textColors.primary};
  font-family: ${theme.uptimeFonts.primary};
`);

export const StyledNameCol = styled(Box)(() => `
  display: flex;
  align-items: center;
  padding-left: 14px;
`)

export const StyledHyperLink = styled(HyperLink)(({ theme }: { theme: UptimeTheme }) => `
  font-size: ${theme.uptimeFontSizes.desktop.fz1}px !important;
  font-family: ${theme.uptimeFonts.primary} !important;
  color: ${theme.uptimeColors.textColors.primary} !important;
  font-weight: 500;
`)
